// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"CommonPageFrame_footerWrapper__Eg_Yh"};